import { matchesLoadedChatFilters } from './canonicalChatFilterModel';

const listeners = new Set();
export const subscribeUnreadCounts = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export const publishUnreadCountChange = change => listeners.forEach(listener => listener(change));
export function exactUnreadCount(results) {
  return results.length && results.every(item => item?.count_is_exact === true && Number.isSafeInteger(item.count) && item.count >= 0)
    ? results.reduce((total, item) => total + item.count, 0) : null;
}
// A sparse first observation has no previous unread state. Do not invent one.
export function unreadTransition(previous, next) {
  const before = previous?.viewer_state?.unread_count, after = next?.viewer_state?.unread_count;
  if (after == null || before === after) return 0;
  if (before == null) return null;
  return Number(after > 0) - Number(before > 0);
}
export function matchesCountScope(conversation, params, actor, loadedIds) {
  if (conversation?.channel_account_id !== params.channel_account_id) return false;
  const withoutUnread = { ...params, unread: false, view: params.view === 'unread' ? 'all' : params.view };
  // Search/query activity cannot be proved from a partial resource.
  if ((params.search || params.query_activity) && !loadedIds.has(conversation.id)) return false;
  if ((params.assigned_to || ['assigned_to_me', 'unassigned'].includes(params.view)) && !conversation.assignment) return false;
  if ((params.lifecycle_status || ['open', 'pending', 'resolved', 'expired'].includes(params.view)) && !conversation.lifecycle_status) return false;
  if (params.view === 'favourites' && conversation.viewer_state?.starred == null) return false;
  return matchesLoadedChatFilters(conversation, withoutUnread, actor);
}
